import { Close16 } from "@carbon/icons-react";
import { Col, Row, Spin, Switch } from "antd";
import { formatDate } from "helpers/date-time";
import { EmailRemindConfigFilter } from "models/EmailRemindConfig";
import { Button, InputText, Select, StandardTable } from "react3l-ui-library";
import useEmailRemindConfigPreviewHook from "./EmailRemindConfigPreviewHook";

function EmailRemindConfigPreview() {
  const {
    translate,
    handleGoMaster,
    model,
    columns,
    listEmailReminderSchedules,
    loadingPreview,
  } = useEmailRemindConfigPreviewHook();
  return (
    <Spin spinning={loadingPreview}>
      <div className="page-content page-content-dxg" id="page-content-dxg-id">
        <div className="info-   component ml-4 mb-3">
          <span>{translate("emailRemindConfig.master.header")}</span>
          <span> &gt; </span>
          <span className="info-primary">
            {translate("emailRemindConfig.master.subHeader")}
          </span>
        </div>
        <div className="pt-3 pl-3 pb-3 d-flex justify-content-between background-w-dxg border-tl-8-dxg border-bottom">
          <h5 className="font-bold ml-3">
            {translate("general.detail.title")}
          </h5>
          <div className="mr-3">
            <Button
              type="secondary"
              className="btn--lg btn-red"
              icon={<Close16 />}
              onClick={handleGoMaster}
            >
              {translate("general.actions.close")}
            </Button>
            {/* <Button
              type="secondary"
              className="btn--lg btn-orange-export ml-3"
              icon={<Time16 />}
              onClick={handleGoHistory(model?.id)}
            >
              {translate("general.actions.viewHistory")}
            </Button> */}
          </div>
        </div>
        <div className="page page-detail border-tl-0-dxg p-t--lg p-l--xxl p-r--xxl p-b--lg">
          <div className="page-detail__title p-b--lg">
            {translate("emailRemindConfig.infoTitle")}
          </div>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="w-100">
            <Col lg={6} className="m-b--xs m-t--xs">
              <InputText
                isRequired
                label={translate("emailRemindConfig.code")}
                type={0}
                value={model.code?.toString()}
                placeHolder={translate("emailRemindConfig.placeholder.code")}
                className={"tio-account_square_outlined"}
                disabled
              />
            </Col>
            <Col lg={6} className="m-b--xs m-t--xs">
              <InputText
                isRequired
                label={translate("emailRemindConfig.name")}
                type={0}
                value={model.name}
                placeHolder={translate("emailRemindConfig.placeholder.name")}
                className={"tio-account_square_outlined"}
                disabled
              />
            </Col>
            <Col lg={6} className="m-b--xs m-t--xs">
              <Select
                isRequired
                label={translate("emailRemindConfig.applicableFunction")}
                type={0}
                classFilter={EmailRemindConfigFilter}
                searchProperty={"name"}
                placeHolder={translate(
                  "emailRemindConfig.placeholder.applicableFunction"
                )}
                // getList={emailRemindConfigRepository.filter}
                disabled
                value={model.applyFunction}
              />
            </Col>
            <Col lg={6} className="m-b--xs m-t--xs">
              <div>
                <div className={"label-status"}>
                  {translate("emailRemindConfig.status")}
                </div>
                <Switch
                  checked={model.statusId === 1 ? true : false}
                  className={"switch_status"}
                  disabled
                />
              </div>
            </Col>
            <Col lg={12} className="m-b--xs m-t--xs">
              <InputText
                label={translate("emailRemindConfig.description")}
                type={0}
                value={model.description}
                placeHolder={translate(
                  "emailRemindConfig.placeholder.description"
                )}
                className={"tio-account_square_outlined"}
                maxLength={500}
                showCount
                isRequired
                disabled
              />
            </Col>
            <Col lg={6} className="m-b--xs m-t--xs">
              <InputText
                isRequired
                label="Template Code"
                type={0}
                value={model?.applyFunction?.templateCode ?? ""}
                placeHolder="Nhập template code"
                className={"tio-account_square_outlined"}
                disabled
              />
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="w-100">
            {/* Người tạo */}
            <Col lg={6} className="m-b--xs m-t--xs">
              <InputText
                label={translate("emailRemindConfig.createdBy")}
                type={0}
                value={model.createdBy?.name}
                className={"tio-account_square_outlined"}
                disabled
              />
            </Col>
            {/* Ngày tạo */}
            <Col lg={6} className="m-b--xs m-t--xs">
              <InputText
                label={translate("emailRemindConfig.createdAt")}
                type={0}
                value={model.createdAt ? formatDate(model.createdAt) : ""}
                placeHolder={translate(
                  "emailRemindConfig.placeholder.createdAt"
                )}
                className={"tio-account_square_outlined"}
                disabled
              />
            </Col>
            {/* Người cập nhật */}
            <Col lg={6} className="m-b--xs m-t--xs">
              <InputText
                label={translate("emailRemindConfig.updatedBy")}
                type={0}
                value={model.updatedBy?.name}
                className={"tio-account_square_outlined"}
                disabled
              />
            </Col>
            {/* Ngày cập nhật */}
            <Col lg={6} className="m-b--xs m-t--xs">
              <InputText
                label={translate("emailRemindConfig.updatedAt")}
                type={0}
                value={model.updatedAt ? formatDate(model.updatedAt) : ""}
                className={"tio-account_square_outlined"}
                disabled
              />
            </Col>
          </Row>
          <div className="page-detail__title p-t--md">
            {translate("emailRemindConfig.calendarReminder")}
          </div>

          <div className="permission-role-detai_content_table">
            <div className="page page-master m-b--lg m-t--sm">
              <div className="page-master__content-table">
                <StandardTable
                  rowKey={"id"}
                  columns={columns}
                  dataSource={listEmailReminderSchedules}
                  isDragable={true}
                  tableSize={"md"}
                  scroll={{ x: 1000 }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Spin>
  );
}

export default EmailRemindConfigPreview;
